(function () {
  const STORAGE_KEY = 'infospeed:wishlist';

  // Same mapping as snippets/catalog-product-card.liquid's {% case product.handle %}
  // block — kept in sync manually since this card is built client-side from
  // the /products/{handle}.js response, which has no access to that Liquid.
  const DEMO_PDF_BY_HANDLE = {
    'focus-gradinița-grupa-mare-5-6-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-gradinita-grupa-mare.pdf',
    'focus-clasa-pregatitoare-6-7-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-clasa-pregatitoare.pdf',
    'focus-clasa-i-7-8-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-clasa-1.pdf',
    'focus-clasa-a-ii-a-8-9-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-clasa-2.pdf',
    'focus-clasa-a-iii-a-9-10-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-clasa-3.pdf',
    'focus-clasa-a-iv-a-10-11-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-clasa-4.pdf',
    'focus-clasa-a-v-a-11-12-ani': 'https://cdn.shopify.com/s/files/1/1058/9447/8164/files/mapa-demo-focus-plus-clasa-5.pdf',
  };

  const DOWNLOAD_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="16" height="16">' +
    '<path d="M10 3v9m0 0 3.5-3.5M10 12 6.5 8.5M4 14.5v1a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-1" ' +
    'stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const SPINNER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">' +
    '<circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';

  // Mirrors snippets/buy-buttons.liquid's <product-form> markup (native
  // Dawn add-to-cart, with its loading-spinner and cart-drawer wiring from
  // assets/product-form.js) so this client-rendered card behaves identically
  // to the real product page instead of a bespoke fetch call.
  function renderAddToCartForm(variantId, available, label) {
    const disabled = available === false || !variantId ? ' disabled' : '';
    return (
      '<product-form class="catalog-product-card__form" data-hide-errors="true">' +
        '<form method="post" action="/cart/add" class="form" novalidate="novalidate" data-type="add-to-cart-form">' +
          '<input type="hidden" name="id" value="' + escapeHtmlStatic(variantId) + '" class="product-variant-id"' + disabled + '>' +
          '<button type="submit" name="add" class="button button--accent catalog-product-card__button"' + disabled + '>' +
            '<span>' + escapeHtmlStatic(label) + '</span>' +
            '<div class="loading__spinner hidden">' + SPINNER_SVG + '</div>' +
          '</button>' +
        '</form>' +
      '</product-form>'
    );
  }

  function escapeHtmlStatic(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // Always renders this slot, even without a demo PDF (hidden via
  // visibility, not omitted) — otherwise the primary add-to-cart button
  // sits at a different height on cards with vs. without the demo button.
  function renderDemoButton(demoPdfUrl) {
    const hiddenClass = demoPdfUrl ? '' : ' catalog-product-card__button--demo-hidden';
    const hiddenAttrs = demoPdfUrl ? '' : ' aria-hidden="true" tabindex="-1"';
    return (
      '<a href="' + escapeHtmlStatic(demoPdfUrl || '#') + '" class="button button--secondary catalog-product-card__button catalog-product-card__button--demo' + hiddenClass + '" target="_blank" rel="noreferrer noopener"' + hiddenAttrs + '>' +
        '<span class="svg-wrapper" aria-hidden="true">' + DOWNLOAD_ICON_SVG + '</span>' +
        'Descarcă mapa demo' +
      '</a>'
    );
  }

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function setWishlist(handles, changed) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      // localStorage unavailable (private mode, quota, etc.) — fail silently.
    }
    const detail = Object.assign({ handles: handles }, changed);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: detail }));
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function toggleWishlist(handle) {
    const handles = getWishlist();
    const index = handles.indexOf(handle);
    const added = index === -1;

    if (added) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }

    setWishlist(handles, { added: added, handle: handle });
    return added;
  }

  function updateButtons() {
    const handles = getWishlist();

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const handle = button.getAttribute('data-product-handle');
      const active = handles.indexOf(handle) > -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const label = button.querySelector('[data-wishlist-label]');
      if (label) {
        const text = active
          ? label.getAttribute('data-label-remove')
          : label.getAttribute('data-label-add');
        if (text) label.textContent = text;
      }
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = handles.length;
    });

    document.querySelectorAll('[data-wishlist-count-wrapper]').forEach((el) => {
      el.classList.toggle('hidden', handles.length === 0);
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();

    const handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    toggleWishlist(handle);
  });

  document.addEventListener('wishlist:updated', updateButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateButtons);
  } else {
    updateButtons();
  }

  window.Wishlist = {
    STORAGE_KEY: STORAGE_KEY,
    get: getWishlist,
    set: setWishlist,
    toggle: toggleWishlist,
    isWishlisted: isWishlisted,
  };

  // Formats an amount in cents using a Shopify money_format string
  // (e.g. "{{amount}}", "${{amount}}", "{{amount_with_comma_separator}} lei").
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '{{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      const decimalPart = parts[1] ? decimal + parts[1] : '';

      return dollars + decimalPart;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  window.Wishlist.formatMoney = formatMoney;

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.emptyState = this.querySelector('[data-wishlist-empty]');
      this.loadingState = this.querySelector('[data-wishlist-loading]');
      this.moneyFormat = this.getAttribute('data-money-format') || '{{amount}}';

      const heartIconTemplate = this.querySelector('[data-wishlist-heart-icon]');
      this.heartIconMarkup = heartIconTemplate ? heartIconTemplate.innerHTML : '';
      this.removeLabel = this.getAttribute('data-remove-label') || '';
      this.viewProductLabel = this.getAttribute('data-view-product-label') || 'Adaugă în coș';

      this.renderFromStorage();

      this.onUpdate = () => this.renderFromStorage();
      document.addEventListener('wishlist:updated', this.onUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:updated', this.onUpdate);
    }

    async renderFromStorage() {
      const handles = getWishlist();

      if (!handles.length) {
        if (this.grid) this.grid.innerHTML = '';
        if (this.emptyState) this.emptyState.hidden = false;
        if (this.loadingState) this.loadingState.hidden = true;
        return;
      }

      if (this.emptyState) this.emptyState.hidden = true;
      if (this.loadingState) this.loadingState.hidden = false;

      const products = await Promise.all(
        handles.map((handle) =>
          fetch('/products/' + handle + '.js')
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
      );

      if (this.loadingState) this.loadingState.hidden = true;

      const validProducts = products.filter(Boolean);

      if (!validProducts.length) {
        if (this.emptyState) this.emptyState.hidden = false;
        if (this.grid) this.grid.innerHTML = '';
        return;
      }

      if (this.grid) {
        this.grid.innerHTML = validProducts.map((product) => this.renderCard(product)).join('');
      }
    }

    // Matches snippets/catalog-product-card.liquid (used on /produse and the
    // homepage's "Produsele noastre"), so wishlisted products look the same
    // wherever they're shown. That snippet's styles live in the standalone
    // component-catalog-product-card.css asset (not a Liquid {% stylesheet %}
    // block) specifically so this JS-rendered page can load them too.
    renderCard(product) {
      const rawImage = product.featured_image || (product.images && product.images[0]);
      const image = this.resizeImage(rawImage, 700);
      const price = formatMoney(product.price, this.moneyFormat);
      const hasCompareAt = product.compare_at_price && product.compare_at_price > product.price;
      const compareAtPrice = hasCompareAt ? formatMoney(product.compare_at_price, this.moneyFormat) : '';
      const description = this.truncateWords(product.description, 22);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const defaultVariant = variants.find((variant) => variant.available) || variants[0] || product;
      const demoPdfUrl = DEMO_PDF_BY_HANDLE[product.handle] || '';
      const url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'products/' + product.handle
        : '/products/' + product.handle;

      return (
        '<li class="grid__item" data-wishlist-card="' + this.escapeHtml(product.handle) + '">' +
          '<div class="catalog-product-card">' +
            '<div class="catalog-product-card__media-wrapper">' +
              '<a href="' + this.escapeHtml(url) + '" class="catalog-product-card__media-link">' +
                '<div class="catalog-product-card__media catalog-product-card__media--square">' +
                  (image
                    ? '<img src="' + this.escapeHtml(image) + '" alt="' + this.escapeHtml(product.title) + '" loading="lazy" width="700" height="700">'
                    : '') +
                '</div>' +
              '</a>' +
              '<button type="button" class="wishlist-button is-active" data-wishlist-toggle data-product-handle="' + this.escapeHtml(product.handle) + '" aria-pressed="true">' +
                '<span class="svg-wrapper wishlist-button__icon">' + this.heartIconMarkup + '</span>' +
                '<span class="visually-hidden">' + this.escapeHtml(this.removeLabel) + '</span>' +
              '</button>' +
            '</div>' +
            '<div class="catalog-product-card__content">' +
              '<h3 class="catalog-product-card__title"><a href="' + this.escapeHtml(url) + '">' + this.escapeHtml(product.title) + '</a></h3>' +
              (description ? '<p class="catalog-product-card__description">' + this.escapeHtml(description) + '</p>' : '') +
              '<div class="catalog-product-card__price">' +
                (compareAtPrice ? '<s>' + compareAtPrice + '</s> ' : '') +
                price +
              '</div>' +
              '<div class="catalog-product-card__actions">' +
                renderAddToCartForm(defaultVariant.id, defaultVariant.available, this.viewProductLabel) +
                renderDemoButton(demoPdfUrl) +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    truncateWords(html, wordCount) {
      const text = (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      if (!text) return '';
      const words = text.split(' ');
      if (words.length <= wordCount) return text;
      return words.slice(0, wordCount).join(' ') + '...';
    }

    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    resizeImage(url, size) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
    }
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPage);
  }
})();
